import React from 'react';
import { EU_HEX, hexToPx } from '../data/map.js';

// ============================================================
// Hex-tile Europe map
// ============================================================

export function EuropeMap({ orgs, selectedCountries, onToggleCountry, counts, maxCount, activeColor }) {
  const sel = selectedCountries || new Set();
  const radius = 40;
  const positions = EU_HEX.map(h => {
    const { x, y } = hexToPx(h.col, h.row, radius);
    return { ...h, x, y };
  });
  const maxX = Math.max(...positions.map(p => p.x)) + radius + 20;
  const maxY = Math.max(...positions.map(p => p.y)) + radius + 20;

  const hexPath = (cx, cy, r) => {
    const pts = [];
    for (let i = 0; i < 6; i++) {
      const a = (Math.PI / 3) * i + Math.PI / 6;
      pts.push(`${cx + r * Math.cos(a)},${cy + r * Math.sin(a)}`);
    }
    return `M ${pts.join(' L ')} Z`;
  };

  return (
    <div className="europe-map">
      <svg viewBox={`0 0 ${maxX} ${maxY}`} width="100%" height="100%" preserveAspectRatio="xMidYMid meet">
        <defs>
          <pattern id="hexpattern" width="6" height="6" patternUnits="userSpaceOnUse">
            <circle cx="3" cy="3" r="0.5" fill="rgba(0,0,0,0.08)"/>
          </pattern>
        </defs>
        {positions.map(p => {
          const c = counts[p.key] || 0;
          const isSelected = sel.has(p.key);
          const isDimmed = sel.size > 0 && !isSelected;
          const intensity = maxCount > 0 ? c / maxCount : 0;
          // Color scale: warm off-white → brand amber/olive
          const alpha = c === 0 ? 0 : 0.15 + intensity * 0.75;
          const fill = c === 0 ? 'rgba(255,255,255,0.5)' : `${activeColor}${Math.round(alpha * 255).toString(16).padStart(2,'0')}`;
          return (
            <g key={p.iso} className={`hex ${isDimmed ? 'dimmed' : ''} ${c === 0 ? 'empty' : ''}`}
               onClick={() => c > 0 && onToggleCountry(p.key)}
               style={{ cursor: c > 0 ? 'pointer' : 'default' }}>
              <path d={hexPath(p.x, p.y, radius)} 
                    fill={fill}
                    stroke={isSelected ? '#1A1A1A' : 'rgba(40,40,40,0.35)'}
                    strokeWidth={isSelected ? 2.5 : 1}/>
              <text x={p.x} y={p.y - 4} textAnchor="middle" className="hex-iso">{p.iso.replace('UK-','')}</text>
              {c > 0 && <text x={p.x} y={p.y + 13} textAnchor="middle" className="hex-count">{c}</text>}
            </g>
          );
        })}
      </svg>
    </div>
  );
}
